document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cro-desc-wrap').forEach(function (wrap) {
    var content = wrap.querySelector('.cro-desc-content');
    var toggle = wrap.querySelector('.cro-desc-toggle');
    if (!content || !toggle) return;

    if (content.scrollHeight <= content.clientHeight + 4) {
      toggle.hidden = true;
      return;
    }

    toggle.addEventListener('click', function () {
      var expanded = wrap.getAttribute('data-expanded') === 'true';
      wrap.setAttribute('data-expanded', String(!expanded));
      toggle.textContent = expanded ? 'Voir plus' : 'Voir moins';
    });
  });
});
